module.exports = __webpack_public_path__ + "evo.png?ecc18bb733a3497cf467409764fbc0a2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/evo.png
// module id = 37
// module chunks = 0